import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import NewsletterSection from '../sections/NewsletterSection';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-primary-bg">
      <Header />
      <main className="relative">
        {children}
      </main>
      <NewsletterSection />
      <Footer />
    </div>
  );
};

export default Layout;

